'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentConfiguration = require('./componentConfiguration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComponentBase = function (_React$Component) {
	_inherits(ComponentBase, _React$Component);

	function ComponentBase(props, context) {
		_classCallCheck(this, ComponentBase);

		var _this = _possibleConstructorReturn(this, (ComponentBase.__proto__ || Object.getPrototypeOf(ComponentBase)).call(this, props, context));

		_this.state = {};
		return _this;
	}

	_createClass(ComponentBase, [{
		key: 'getComponentName',
		value: function getComponentName() {
			var constructor = this.constructor;
			return constructor.displayName || constructor.name || undefined;
		}
	}, {
		key: '_bind',
		value: function _bind() {
			var _this2 = this;

			for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
				methods[_key] = arguments[_key];
			}

			methods.forEach(function (method) {
				if (!_this2[method]) {
					console.warn('Missing method: ' + method);
				} else {
					_this2[method] = _this2[method].bind(_this2);
				}
			});
		}
	}, {
		key: 'translate',
		value: function translate(id, values) {
			if (this.context.intl) {
				return this.context.intl.formatMessage({ id: id }, values);
			} else {
				return id;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props;
			var error = _props.error;
			var loading = _props.loading;
			var retry = _props.retry;
			var loadingOptions = _props.loadingOptions;
			var delayRendering = this.state.delayRendering;


			if (error) {
				return this.renderErrorWrapper(this.renderError(retry));
			} else if (loading || delayRendering) {
				return this.renderLoadingWrapper(this.renderLoading(loadingOptions));
			} else {
				return this.renderComponent();
			}
		}
	}, {
		key: 'renderErrorWrapper',
		value: function renderErrorWrapper(content) {
			return content;
		}
	}, {
		key: 'renderLoadingWrapper',
		value: function renderLoadingWrapper(content) {
			return content;
		}
	}, {
		key: 'renderError',
		value: function renderError(retry) {
			return (0, _componentConfiguration.renderErrorState)(retry);
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading(loadingOptions) {
			return (0, _componentConfiguration.renderLoadingState)(loadingOptions);
		}
	}]);

	return ComponentBase;
}(_react2.default.Component);

exports.default = ComponentBase;

ComponentBase.contextTypes = {
	intl: _react.PropTypes.object,
	error: _react.PropTypes.bool,
	loading: _react.PropTypes.bool,
	retry: _react.PropTypes.func
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-component/dist/ComponentBase.js
 ** module id = 628
 ** module chunks = 0
 **/